import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: 'Minimum should be less or equal to maximum'
 */
export class MinimoMenorIgualMaximoParser implements ErrorParser {
    public puedeLeerError(error: { [key: string]: string[] }): boolean {
        if (!isObject(error)) {
            return false;
        }
        if (!error.hasOwnProperty("non_field_errors")) {
            return false;
        }
        return error.non_field_errors[0].includes("Item selection maximum must be greater or equal to item selection minimum");
    }

    public traducir(_error: string): string {
        return "El valor minimo debe ser menor o igual al maximo";
    }

}
